import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../../components/text/text';
import { TextComponentType } from '../../text/types/component';
import { StyledHelperTextWrapper, StyledLeftHelperText, StyledRightHelperText, } from './sliderHelperTextStandAlone.styled';
/**
 * @description
 * SliderHelperTextStandAlone component is used to display helper text for the slider.
 * It can be displayed on the left or right side of the slider.
 */
export const SliderHelperTextStandAlone = ({ leftHelperText, leftHelperTextId, rightHelperText, rightHelperTextId, styles, state, }) => {
    if (!leftHelperText && !rightHelperText) {
        return null;
    }
    return (_jsxs(StyledHelperTextWrapper, { styles: styles, children: [leftHelperText && (_jsx(StyledLeftHelperText, { styles: styles, children: _jsx(Text, { component: TextComponentType.SPAN, customTypography: styles?.states?.[state]?.helperText, id: leftHelperTextId, children: leftHelperText }) })), rightHelperText && (_jsx(StyledRightHelperText, { styles: styles, children: _jsx(Text, { component: TextComponentType.SPAN, customTypography: styles?.states?.[state]?.helperText, id: rightHelperTextId, children: rightHelperText }) }))] }));
};
//# sourceMappingURL=sliderHelperTextStandAlone.js.map